"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ApplyButton = _interopRequireDefault(require("../ApplyButton"));

var _NightsInfo = _interopRequireDefault(require("../NightsInfo"));

var _FlexDatesPicker = _interopRequireDefault(require("../Calendar/components/FlexDatesPicker"));

var _utils = require("../../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Footer = function Footer(props) {
  var _props$isMobile = props.isMobile,
      isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
      isShownDirectFlightsLegend = props.isShownDirectFlightsLegend,
      applyButtonHandler = props.applyButtonHandler,
      leftValue = props.leftValue,
      rightValue = props.rightValue,
      nights = props.nights,
      isHotelOnly = props.isHotelOnly,
      onChangeShift = props.onChangeShift,
      currentShift = props.currentShift,
      isHotelVariant = props.isHotelVariant;

  var _convertDatePickerPar = (0, _utils.convertDatePickerParamsToStrings)({
    leftValue: leftValue,
    rightValue: rightValue,
    nights: nights
  }),
      left = _convertDatePickerPar.left,
      right = _convertDatePickerPar.right;

  var isApplyButton = left && right;
  var buttonRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (buttonRef.current) buttonRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(StyledFooter, {
    $isMobile: isMobile
  }, !isHotelVariant && /*#__PURE__*/_react["default"].createElement(FlexDatesPicker, {
    onChangeShift: onChangeShift,
    currentShift: currentShift,
    $isMobile: isMobile
  }), isApplyButton ? /*#__PURE__*/_react["default"].createElement(StyledApplyButton, {
    onClick: applyButtonHandler,
    buttonRef: buttonRef,
    $isMobile: isMobile,
    isHotelVariant: isHotelVariant
  }, /*#__PURE__*/_react["default"].createElement(DatesText, null, "".concat(left, " - ").concat(right, ","), "\xA0"), /*#__PURE__*/_react["default"].createElement(_NightsInfo["default"], {
    startDateCell: leftValue,
    endDateCell: rightValue,
    nights: nights,
    isMobile: isMobile,
    isHotelVariant: isHotelVariant
  })) : !isHotelOnly && !isHotelVariant && isShownDirectFlightsLegend && /*#__PURE__*/_react["default"].createElement(DirectFlightLegend, {
    $isMobile: isMobile
  }, "\u041F\u0440\u044F\u043C\u043E\u0439 \u043F\u0435\u0440\u0435\u043B\u0435\u0442"));
};

exports.Footer = Footer;
var StyledApplyButton = (0, _styledComponents["default"])(_ApplyButton["default"]).withConfig({
  displayName: "Footer__StyledApplyButton",
  componentId: "sc-gayepy-0"
})(["width:auto;margin-left:auto;", ";"], function (_ref) {
  var $isMobile = _ref.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["width:100%;height:43px !important;"]);
});

var DirectFlightLegend = _styledComponents["default"].div.withConfig({
  displayName: "Footer__DirectFlightLegend",
  componentId: "sc-gayepy-1"
})(["display:flex;align-items:center;font-weight:normal;color:var(--black);", " &:before{content:'';width:24px;height:24px;background:var(--teallight);display:block;margin-right:8px;border-radius:8px;}"], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile ? 'margin: 0 auto;' : 'margin-left: auto;';
});

var FlexDatesPicker = (0, _styledComponents["default"])(_FlexDatesPicker["default"]).withConfig({
  displayName: "Footer__FlexDatesPicker",
  componentId: "sc-gayepy-2"
})(["", ";"], function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile ? (0, _styledComponents.css)(["margin-bottom:16px;max-width:100%;& button{flex:1;}"]) : (0, _styledComponents.css)(["& > button:first-of-type{max-width:111px;width:100%;}"]);
});

var StyledFooter = _styledComponents["default"].div.withConfig({
  displayName: "Footer__StyledFooter",
  componentId: "sc-gayepy-3"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;clear:both;padding:0 16px;box-sizing:border-box;", ";"], function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile && "\n      position: fixed;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      padding: 8px;\n      background: #fff;\n      width: 100%;\n      z-index: 1;\n      flex-direction: column;\n    ";
});

var DatesText = _styledComponents["default"].div.withConfig({
  displayName: "Footer__DatesText",
  componentId: "sc-gayepy-4"
})(["display:flex;align-items:center;"]);